import Image from 'next/legacy/image';
import styles from './footer.module.scss';
import { FooterState, footerStructureData } from './footer.data';
import { Themes } from '@layouts/main-layout/themes.enum';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

type FooterProps = {
  theme?: Themes;
};

const Footer = ({ theme }: FooterProps) => {
  const { logo, rights, brand, year, firstRow, secondRow, social, contacts, footerRightsText } = FooterState;
  const t = useTranslations();

  theme = theme || Themes.Default;

  return (
    <footer className={`${styles.footer} ${styles[theme]}`}>
      <div className={styles.footer__wrapper}>
        <div className={styles.footer__navigation}>
          {firstRow.map((col, colIndex) => (
            <div className={styles.footer__column} key={colIndex}>
              <h3 className={styles.footer__column__title}>{t(col.title)}</h3>
              {col.links.map((link, linkIndex) => (
                <div className={styles.footer__column__link} key={linkIndex}>
                  <Link href={link.href} legacyBehavior>
                    <a className={styles.footer__link}>{t(link.title)}</a>
                  </Link>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className={styles.footer__navigation}>
          {secondRow.map((col, colIndex) => (
            <div className={styles.footer__column} key={colIndex}>
              <h3 className={styles.footer__column__title}>{t(col.title)}</h3>
              {col.cards.map((card, cardIndex) => (
                <div className={styles.footer__column__link} key={cardIndex}>
                  <Link href={card.href} legacyBehavior>
                    <a className={styles.footer__link} target={card.newTab ? '_blank' : '_self'} rel={card.newTab ? 'noopener noreferrer' : ''}>{t(card.title)}</a>
                  </Link>
                </div>
              ))}
            </div>
          ))}
          <div className={styles.footer__column}>
            <h3 className={styles.footer__column__title}>{t('Legals.Nav.Title')}</h3>
            <div className={styles.footer__column__link}>
              <a href="https://www.iubenda.com/privacy-policy/94179763 "
                target="_blank" rel="noopener noreferrer"
                className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed"
                title={t('Legals.Nav.PrivacyPolicy')}>
                {t('Legals.Nav.PrivacyPolicy')}</a>
            </div>
            <div className={styles.footer__column__link}>
              <a href="https://www.iubenda.com/privacy-policy/94179763/cookie-policy"
                target="_blank" rel="noopener noreferrer"
                className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed"
                title={t('Legals.Nav.CookiePolicy')}>
                {t('Legals.Nav.CookiePolicy')}</a>
            </div>
            <div className={styles.footer__column__link}>
              <a href="https://www.iubenda.com/terms-and-conditions/94179763"
                target="_blank" rel="noopener noreferrer"
                className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed"
                title={t('Legals.Nav.TermsAndConditions')}>
                {t('Legals.Nav.TermsAndConditions')}</a>
            </div>
          </div>
        </div>
        <div className={styles.footer__social}>
          <div className={styles.footer__social__logo}>
            <Image
              src={logo}
              alt={brand}
              layout="fixed"
              objectFit="contain"
              width={158}
              height={26}
              loading="lazy"
            />
            <div className={styles.footer__rights}>
              &#169; {year} {t(footerRightsText)}
            </div>
          </div>
          <div className={styles.footer__follow}>
            {/* TODO: Temporary hidden */}
            {/* {social.map((item, key) => (
              <a href={item.link} key={key} rel="noreferrer" target="_blank">
                <Image
                  loading="eager"
                  src={item.icon}
                  alt={item.name}
                  layout="fixed"
                  objectFit="contain"
                  width={32}
                  height={32}
                />
              </a>
            ))} */}
          </div>
        </div>
      </div>
      <script
        type={'application/ld+json'}
        dangerouslySetInnerHTML={{ __html: JSON.stringify(footerStructureData) }}
      />
    </footer>
  );
};

export default Footer;
